"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throttledQueue = exports.throttle = void 0;
function throttle(fn, wait) {
    var isCalled = false;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!isCalled) {
            fn.apply(void 0, args);
            isCalled = true;
            setTimeout(function () {
                isCalled = false;
            }, wait);
        }
    };
}
exports.throttle = throttle;
function throttledQueue(fn, wait) {
    var fnQueue = [];
    var isWaiting;
    var executeFn = function (params) {
        isWaiting = true;
        fn(params);
        setTimeout(play, wait);
    };
    var play = function () {
        isWaiting = false;
        if (fnQueue.length) {
            var params = fnQueue.shift();
            executeFn(params);
        }
    };
    return function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        if (isWaiting) {
            fnQueue.push(params);
        }
        else {
            executeFn(params);
        }
    };
}
exports.throttledQueue = throttledQueue;
//# sourceMappingURL=index.js.map